/* global lazySizes */
import Flickity from 'flickity';
import { modulo } from '../utils';


const injectImage = (slideIndex, flkty) => {
    const nextImage = flkty.cells[slideIndex].element.dataset.thumb;
    const infoBox = flkty.selectedElement.querySelector('.hero-carousel__box');

    if (infoBox) {
        infoBox.dataset.bgset = nextImage;
        lazySizes.loader.unveil(infoBox);
    }
};

const slides = Array.from(document.querySelectorAll('.hero-carousel__slide'));

const adjustCellHeights = () => {
    slides.map(slide => slide.classList.toggle('hero-carousel__slide-full-height'));
};

export default(() => {
    const carousel = document.querySelector('.js-hero-carousel');

    if (carousel) {
        const flkty = new Flickity('.js-hero-carousel', {
            wrapAround: true,
            pageDots: false,
            on: {
                ready: () => adjustCellHeights(),
            },
        });

        if (flkty.nextButton) {
            flkty.nextButton.element.addEventListener('mouseover', () => {
                const nextIndex = modulo(flkty.selectedIndex + 1, flkty.slides.length);
                injectImage(nextIndex, flkty);
            });

            flkty.nextButton.element.addEventListener('mouseout', () => {
                injectImage(flkty.selectedIndex, flkty);
            });
        }
    }
})();
